import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tab-panel"
}

import { PropType } from 'vue'
import { ModelThrowComponentsTab } from '..'


export default /*#__PURE__*/_defineComponent({
  __name: 'TabPanel',
  props: {
  val: {
    default: null,
    type: [String, Number, Symbol] as PropType<ModelThrowComponentsTab>
  },
  modelValue: {
    default: null,
    type: [String, Number, Symbol] as PropType<ModelThrowComponentsTab>
  }
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (props.modelValue == props.val)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _createCommentVNode("", true)
}
}

})